<script>
  import InstallButton from "./InstallButton.svelte";
  import { onMount } from "svelte";
  import Twitter from "../utils/twitter";

  onMount(() => {
    Twitter.loadAPI();
    return () => {
      Twitter.unloadAPI();
    };
  });
</script>

<div class="p-2 space-y-1">
  <InstallButton />
  <div class="text-white border-white rounded-xl bg-gray-800 p-2 flex flex-col">
    <p>Follow us on Twitter</p>
    <div class="self-start">
      <a
        href="https://twitter.com/CrossFitTimers?ref_src=twsrc%5Etfw"
        class="twitter-follow-button"
        data-size="large"
        target="_blank"
        rel="noopener noreferrer"
        data-show-screen-name="false"
        data-show-count="false">Follow @CrossFitTimers</a
      >
    </div>
  </div>
  <div class="text-white border-white rounded-xl bg-gray-800 p-2 flex flex-col">
    <p>In case of any questions DM us</p>
    <div class="self-start">
      <a
        href="https://twitter.com/messages/compose?recipient_id=1532249343524315136"
        class="twitter-dm-button"
        data-show-screen-name="false"
        data-size="large"
        target="_blank"
        rel="noopener noreferrer"
      >
        Message
      </a>
    </div>
  </div>
  <div class="text-white border-white rounded-xl bg-gray-800 p-2 flex flex-col">
    <div class="self-start">
      <blockquote class="twitter-tweet">
        <p lang="en" dir="ltr">
          Short user guide<a
            href="https://twitter.com/hashtag/CrossFit?src=hash&amp;ref_src=twsrc%5Etfw"
            >#CrossFit</a
          > <a href="https://t.co/ZzSH8JSNT6">pic.twitter.com/ZzSH8JSNT6</a>
        </p>
        &mdash; CrossFitTimers (@CrossFitTimers)<a
          href="https://twitter.com/CrossFitTimers/status/1549809987479805954?ref_src=twsrc%5Etfw"
          >July 20, 2022</a
        >
      </blockquote>
    </div>
  </div>
</div>
